export { default } from "../extends/_index.mjs"


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux/node_modules/@babel/runtime/helpers/esm/extends.js
// module id = ./node_modules/react-redux/node_modules/@babel/runtime/helpers/esm/extends.js
// module chunks = 2 5